module.exports = __webpack_public_path__ + "img/Explore-01_3@2x.43766e57.png";